import React from "react"

import type { AvailableTextTypography } from "@front-shared/types/elements.types"

import { HtmlHelper } from "../../helpers/html.helper"

export const CoverageBreakdownBadgeElement: React.FunctionComponent<
    ICoverageBreakdownBadgeElementProps
> = props => {
    return HtmlHelper.getHtmlWrappedBadge(
        props.label,
        props.value,
        props.tooltip,
        props.className,
        props.isActive
            ? "bg-brand-lilacLight border-brand-lilac"
            : props.customBgClassName,
        props.labelTypography,
        props.valueTypography,
        props.wrapText,
    )
}

interface ICoverageBreakdownBadgeElementProps {
    className?: string
    label: string | JSX.Element
    value?: string | number | JSX.Element
    tooltip?: string
    isActive?: boolean
    customBgClassName?: string
    labelTypography?: AvailableTextTypography
    valueTypography?: AvailableTextTypography
    wrapText?: boolean
}
